import * as yup from "yup"

export const detailValidationSchema = yup.object().shape({
  qty_received_item: yup.number().label("QTY RECEIVED").required().min(1).max(yup.ref("qty_back_delivered")),
  qty_unit: yup.number().defined(),
  product_id: yup.number().defined(),
  price_received: yup.number().defined(),
  discount: yup.number().defined(),
  total: yup.number().defined(),
  tax_id: yup.number().defined(),
  tax_rate: yup.number().defined(),
  total_tax_paid: yup.number().defined(),
  qty_back_delivered: yup.number().defined(),
  unit_measure: yup.string().defined()
})
export const validationSchema = yup.object().shape({
  coa_cheque_id: yup.string().label("Account Cheque").required(),
  memo: yup.string().label("Memo").required(),
  referensi: yup.string().label("Reference").required(),
  transaction_date: yup.string().label("Date").required(),
  received_reject_detail: yup.array().label("Detail").required().min(1).of(detailValidationSchema)
})

export type FormType = yup.InferType<typeof validationSchema>
export type DetailType = yup.InferType<typeof detailValidationSchema>